import React from 'react';

const fields = [
  ['central_lock', 'ЦЗ', ''], ['fuel_level', 'Топливо / заряд', '%'],
  ['odometer', 'Пробег', 'км'], ['range', 'Запас хода', 'км'],
  ['speed', 'Скорость CAN', 'км/ч'], ['door_fl', 'Дверь FL', ''],
  ['seat_belt', 'Ремень', ''], ['hazard_lights', 'Аварийка', ''],
];
export default function DeviceReadings({readings = {}}) {
  return <section aria-label="Последние показания VEGA">
    {fields.map(([key, label, unit]) => {
      const item = readings[key];
      let value = item && item.value !== null && item.value !== undefined ? `${item.value} ${unit}`.trim() : 'нет данных';
      if (key === 'central_lock' && item && typeof item.locked === 'boolean') value = item.locked ? 'заперт' : 'отперт';
      return <p key={key} style={{margin: '6px 0'}}>
        <strong>{label}: {value}</strong>
        {item && item.recorded_at && <small>{' · '}{new Date(item.recorded_at).toLocaleString('ru-RU')}
          {' · '}{item.source === 'read' ? 'запрос' : 'поток'}{item.stale ? ' · устарело' : ''}</small>}
      </p>;
    })}
    <small>Дверь FL, ремень и аварийка: значения 0/1 без предположения о состоянии. Заряд / топливо — CAN 2803.</small>
  </section>;
}
